import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../Constants/Constants";

export default function ActionButtonTile({ title = "Create New Ticket" }) {
  const navigate = useNavigate();
  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          Quick Actions
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => navigate(ROUTES.TICKETS)}
        >
          {title}
        </Button>
      </CardContent>
    </Card>
  );
}
